import { PngImage } from '../../components/_common/PngImage';
import { ImageContainer, StyledContainer, UnderconstructionBox } from './styles';
import { Row } from 'antd';


const NotFound = () => {
    return (
        <>
            <StyledContainer>
                <Row>
                    <ImageContainer>
                        <PngImage src="underconstruction.png" width="70%" height="70%" />
                    </ImageContainer>
                </Row>
                <Row>
                    <UnderconstructionBox>
                        <p>این قسمت در حال تهیه می باشد و به زودی تکمیل می گردد</p>
                    </UnderconstructionBox>
                </Row>
            
            </StyledContainer>
        </>
    );
};

export default NotFound